var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-content",on:{"click":_vm.onClick}},[_c('div',{staticClass:"titel"},[_c('span',[_vm._v(_vm._s(_vm.stijl.titel))])]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.stijl.img}})])])}
var staticRenderFns = []

export { render, staticRenderFns }